"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NodeFieldContainer = void 0;
const Colors_1 = require("../../../../Colors");
const constants_1 = require("../../../constants");
const react_1 = __importDefault(require("react"));
const typestyle_1 = require("typestyle");
const Main = typestyle_1.style({
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    color: Colors_1.Colors.grey[0],
    height: constants_1.FIELD_HEIGHT,
    margin: `0 0`,
    transition: 'background 0.25s ease-in-out',
    $nest: {
        '&.Active': {
            background: Colors_1.Colors.main[3],
            $nest: {
                '.NodeFieldPort': {
                    backgroundColor: Colors_1.Colors.grey[9],
                    $nest: {
                        '.OpenerIcon': {
                            opacity: 1,
                        },
                    },
                },
            },
        },
        '.NodeFieldPortPlaceholder': {
            width: 24,
            height: 16,
        },
        '&:hover': {
            background: Colors_1.Colors.main[3],
            $nest: {
                '.NodeFieldPort': {
                    backgroundColor: `${Colors_1.Colors.grey[9]}88`,
                    $nest: {
                        '.OpenerIcon': {
                            opacity: 0.5,
                        },
                    },
                },
            },
        },
    },
});
exports.NodeFieldContainer = (_a) => {
    var { children, className = '' } = _a, props = __rest(_a, ["children", "className"]);
    return (react_1.default.createElement("div", Object.assign({ className: [Main, className].join(' ') }, props), children));
};
